import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Selector from '../../../components/from/selector/Selector';
import Fliter, { FliterForm } from '../../../components/table/fliter/Fliter';
import { data_extension } from '../../../config/dataExtension';
import { DataPage } from '../../../config/dataPage';
import { speciality, technology } from '../../../config/technology';
import './DirPickerFliter.css'

export interface IDirPickerFliterData {
    SPECIALITYCLASS?: string,
    FIELD_USERDATACLASS?: number,
    DATA_CATEGORY?: string,
    TECHNOLOGYCLASS?: string,
}



function DirPickerFliter(props: {
    onChanged?: (data: IDirPickerFliterData) => void;
    value?: string; 
}) {
    const [fliterValue, setValue] = useState<IDirPickerFliterData>({});


    useEffect(() => {
        if (props.value == 'diffraction') {
            let value = fliterValue
            value.FIELD_USERDATACLASS = 2
            setValue(value)
        }
        
    }, [props.value])
    return (
        <Fliter className='dir-picker-fliter'>
            <FliterForm>
                <Selector
                    titleId="专业类别"
                    defaultValue={{ value: "select_all" }}
                    object={speciality}
                    value={fliterValue.SPECIALITYCLASS || 'select_all'}
                    onChange={(value) => {
                        const data = {
                            SPECIALITYCLASS: value === 'select_all' ? undefined : value,
                            FIELD_USERDATACLASS: fliterValue.FIELD_USERDATACLASS,
                        }
                        setValue(data);
                        if (props.onChanged) props.onChanged(data);
                    }}
                />
                <Selector
                    titleId="数据属性"
                    // defaultValue={{ value: "原始数据" }}
                    object={{
                        raw: '原始数据',
                        result: '成果数据',
                        report: '专题报告',
                    }}
                    value={fliterValue.FIELD_USERDATACLASS ? (DataPage as any)[fliterValue.FIELD_USERDATACLASS] : 'select_all'}
                    onChange={(value) => {
                        const data = {
                            SPECIALITYCLASS: fliterValue.SPECIALITYCLASS,
                            FIELD_USERDATACLASS: value === 'select_all' ? undefined : (DataPage as any)[value],
                        }
                        setValue(data);
                        if (props.onChanged) props.onChanged(data);
                    }}
                />
                <Selector
                    titleId="data_extension"
                    id="data_extension"
                    object={fliterValue.FIELD_USERDATACLASS && fliterValue.SPECIALITYCLASS && (data_extension as any)[(DataPage as any)[fliterValue.FIELD_USERDATACLASS]] ? (data_extension as any)[(DataPage as any)[fliterValue.FIELD_USERDATACLASS]][fliterValue.SPECIALITYCLASS] : {}}
                    onChange={(value) => {
                        const data = {
                            SPECIALITYCLASS: fliterValue.SPECIALITYCLASS,
                            FIELD_USERDATACLASS: fliterValue.FIELD_USERDATACLASS,
                            DATA_CATEGORY: value === 'select_all' ? undefined : value,
                        }
                        setValue(data);
                        if (props.onChanged) props.onChanged(data);
                    }}
                    value={fliterValue.DATA_CATEGORY || 'select_all'}
                    defaultValue={{ value: "select_all" }}
                />
                <Selector
                    titleId="技术类别"
                    object={(technology as any)[fliterValue.SPECIALITYCLASS || '']}
                    onChange={(value) => {
                        const data: IDirPickerFliterData = {
                            SPECIALITYCLASS: fliterValue.SPECIALITYCLASS,
                            FIELD_USERDATACLASS: fliterValue.FIELD_USERDATACLASS,
                            DATA_CATEGORY: fliterValue.DATA_CATEGORY,
                            TECHNOLOGYCLASS: value === 'select_all' ? undefined : value,
                        }
                        setValue(data);
                        if (props.onChanged) props.onChanged(data);
                    }}
                    defaultValue={{ value: "select_all" }}
                />
            </FliterForm>
        </Fliter>
    )
}

const mapStateToProps = (state: {
    user: { userName: string }
    project: { activeName: string }
}) => {
    return {
        userName: state.user.userName,
        activeProjectName: state.project.activeName
    };
};

export default connect(
    mapStateToProps,
    {}
)(DirPickerFliter);